<template>
  <div>
    <input
      :class="
        `survey-input-xs survey-input-number-xs ${this.importedDataStyling}`
      "
      v-model="controlValue"
      @change="onChangeInput"
      type="number"
      @keydown="handleKeyDown"
      :readonly="readOnlyInputs"
    />
    <kpiObjectiveSpan
      :isKPIthisQuestion="isKPIthisQuestion"
      :foundObjectiveValue="foundObjectiveValue"
    />
  </div>
</template>

<script>
import kpiObjectiveSpan from "./kpiObjectiveSpan";

export default {
  props: [
    "value",
    "label",
    "readOnlyInputs",
    "isKPIthisQuestion",
    "foundObjectiveValue",
    "importedDataStyling"
  ],
  components: {
    kpiObjectiveSpan
  },
  data: function() {
    return {
      controlValue: this.value
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.controlValue = newVal;
    }
  },
  methods: {
    handleKeyDown(event) {
      // [Modified by E2logy]: Prevent decimal point values
      if (
        event.key === "." ||
        event.key === "," ||
        event.keyCode === 190 ||
        event.keyCode === 188
      ) {
        event.preventDefault();
      }
      // handle keydown event here
      if (event.keyCode === 38 || event.keyCode === 40) {
        event.preventDefault();
      }
    },
    onChangeInput() {
      this.$emit("input", this.controlValue);
    }
  }
};
</script>

<style>
input.survey-input-number-xs::-webkit-inner-spin-button,
input.survey-input-number-xs::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  pointer-events: none;
}
</style>
